import MicrocertsTable from './MicrocertTable'
const LearningHubDashboard = ({ learningHubData }) => {


    return (
        <>
            {/* Learning hub Section */}
            <section className="">
                <div className="container">
                    <img
                        src="https://res.cloudinary.com/dueblmbcc/image/upload/v1715861763/DC/Group_21954_bhuhq2.png"
                        className="tag-image"
                        alt="Learning Hub"
                    />
                    <br />
                    <br />

                    {/* Number of Tracks and Certifications Completed */}
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div className="seanalytics-card p-3">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h6 className="text-secondary-2 mb-0">Number of Tracks Completed</h6>
                                    </div>
                                    <div className="col text-end">
                                        <h4 className="mb-0">
                                            <span className="seanalytics-text-danger">
                                                {learningHubData?.["Number of Tracks Completed"]
                                                    ? learningHubData["Number of Tracks Completed"].split("/")[0]
                                                    : "0"}
                                            </span>{" "}
                                            /{" "}
                                            {learningHubData?.["Number of Tracks Completed"]
                                                ? learningHubData["Number of Tracks Completed"].split("/")[1]
                                                : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="seanalytics-card p-3">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h6 className="text-secondary-2 mb-0">Number of Certifications Completed</h6>
                                    </div>
                                    <div className="col text-end">
                                        <h4 className="mb-0">
                                            <span className="seanalytics-text-danger">
                                                {learningHubData?.["Number of Certifications Completed"]
                                                    ? learningHubData["Number of Certifications Completed"].split("/")[0]
                                                    : "0"}
                                            </span>{" "}
                                            /{" "}
                                            {learningHubData?.["Number of Certifications Completed"]
                                                ? learningHubData["Number of Certifications Completed"].split("/")[1]
                                                : "0"}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Certifications Overview */}
                    <div className="seanalytics-card p-3 mb-4">
                        <div className="row">
                            {/* Right Side: Title */}
                            <div className="col-md-3 text-md-end">
                                <h6 className="ana-text">Completed and Incomplete Certifications</h6>
                            </div>
                            {/* Left Side: Status Columns */}
                            <div className="col-md-9">
                                <div className="row text-center seanalytics-cert-status">
                                    <div className="col position-relative">
                                        <h4>{learningHubData?.["Overall Certification Status"]?.Completed || 0}</h4>
                                        <span className="seanalytics-badge seanalytics-bg-success">Completed</span>
                                        <div className="seanalytics-vertical-line"></div>
                                    </div>
                                    <div className="col position-relative">
                                        <h4>{learningHubData?.["Overall Certification Status"]?.["Not Completed"] || 0}</h4>
                                        <span className="seanalytics-badge seanalytics-bg-warning">Not Completed</span>
                                        <div className="seanalytics-vertical-line"></div>
                                    </div>
                                    <div className="col">
                                        <h4>{learningHubData?.["Overall Certification Status"]?.["In Progress"] || 0}</h4>
                                        <span className="seanalytics-badge seanalytics-bg-info">In Progress</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Microcerts Table */}
                    <MicrocertsTable microcerts={learningHubData?.["List of Microcerts"]} />


                    <br />
                </div>
            </section>


        </>
    );
};

export default LearningHubDashboard;
